import React from 'react';
import './Home.css';
import Product from './Product';

function Home() {
  return (
    <div className="home">
      <div className="home__container">
        <img className="home__image"
          src="https://images-eu.ssl-images-amazon.com/images/G/02/digital/video/merch2016/Hero/Covid19/Generic/GWBleedingHero_ENG_COVIDUPDATE__XSite_1500x600_PV_en-GB._CB428684220_.jpg"
          alt=""
        />
        <div className="home__row">
          <Product
            id="100"
            title="The Lean Startup"
            price={29.99}
            image={"https://images-na.ssl-images-amazon.com/images/I/51Zymoq7UnL._AC_SY400.jpg"}
            rating={3}
          />
          <Product
            id="101"
            title="Borosil Stainless Steel Hydra Nova - Vacuum Insulated Flask Water Bottle, 500 ML, Blue "
            price={12.99}
            image={"https://images-na.ssl-images-amazon.com/images/I/41tnPeKVlhL._SL1000_.jpg"}
            rating={2}
          />
        </div>
        <div className="home__row">
          <Product
            id="110"
            title="HP KM300F Gaming Keyboard and Mouse Combo (8AA01AA)"
            price={34.88}
            image={"https://images-na.ssl-images-amazon.com/images/I/71GjYVXrSpL._SL1500_.jpg"}
            rating={4}
          />
          <Product
            id="111"
            title="Google Play Gift Card"
            price={25.49}
            image={"https://images-eu.ssl-images-amazon.com/images/I/21hKgQO2frL.jpg"}
            rating={2}
          />
          <Product
            id="1000"
            title="ZOTAC GeForce GTX 1660 Twin Fan 6GB GDDR5 192-bit Super Compact Gaming Graphics Card (ZT-T16600K-10M) "
            price={24.99}
            image={"https://images-na.ssl-images-amazon.com/images/I/71EMGwJsMOL._SL1500_.jpg"}
            rating={5}
          />
        </div>
        <div className="home__row">
          <Product
            id="1001"
            title="Dell U-Series 37.5 Screen LED-Lit Monitor U3818DW"
            price={499.89}
            image={"https://images-na.ssl-images-amazon.com/images/I/71RS-pt9QTL._SL1280_.jpg"}
            rating={4}
          />
        </div>
      </div>

    </div>
  );
}

export default Home;


